<ng-container *ngIf="data">
    <div class="preview-main-wrapper">
        <div class="preview-wrapper">
            <div class="preview-header d-flex align-items-end"
                [ngStyle]="{'background-image': 'url(' + data.banner_url + ')'}">

            </div>
            <div class="header-caption">
                <span [ngStyle]="{'color': data.colors.secondary_color}">{{data.headings.main}}</span>
                <p [ngStyle]="{'color': data.colors.secondary_color}" *ngIf="data.headings.meta">{{data.headings.meta}}
                </p>
                <i *ngIf="data.website">
                    <a [href]="functionService.forceUrl(data.website)"
                        [ngStyle]="{'color': data.colors.secondary_color, 'text-decoration-color': data.colors.secondary_color}">
                        <i class="bi bi-link"></i>
                        {{data.website}}</a>
                </i>
            </div>
            <div class="preview-body">
                <div class="preview-imgs row p-0 m-0">
                    <div class="col p-0 m-0" *ngFor="let _ of [].constructor(layout_columns); let i = index">
                        <ng-container *ngFor="let image of images; let ii = index">
                            <ng-container *ngIf="ii%layout_columns===i">
                                <ng-template *ngTemplateOutlet="showGalleryItem; context: {image, i}"></ng-template>
                            </ng-container>
                        </ng-container>
                    </div>
                    <ng-template #showGalleryItem let-image="image" let-i="i">
                        <div class="image-container fadeIn animated delay-{{i}}" (click)="openGallery(image, $event)">
                            <img loading="lazy" [src]="image.location.thumbnail.url"
                                *ngIf="!isVideoFile(image.location.thumbnail.url); else isVideo"
                                [alt]="image.file_name">
                            <ng-template #isVideo>
                                <video controls>
                                    <source [src]="image.location.original.url" type="video/mp4">
                                    Your browser does not support the video tag.
                                </video>
                            </ng-template>

                            <div class="image-overlay-download" *ngIf="data.downloadable"
                                (click)="downloadMemory(image)"
                                [ngStyle]="{'background-color': 'rgba(' + functionService.hexToRgb(data.colors.primary_color).join(',') + ', 50%)', 'color': data.colors.text_color}">
                                <i class="bi bi-cloud-arrow-down"></i>
                            </div>

                            <div class="image-overlay" *ngIf="image.caption"
                                [ngStyle]="{'background-color': 'rgba(' + functionService.hexToRgb(data.colors.primary_color).join(',') + ', 50%)', 'color': data.colors.text_color}">
                                <i
                                    class="bi {{isVideoFile(image.location.original.url) ? 'bi-camera-reels-fill' : 'bi-image'}} me-2"></i>
                                {{image.caption}}
                            </div>

                        </div>
                    </ng-template>
                </div>
                <div *ngIf="loading" class="preview-placeholders">
                    <p class="placeholder-glow w-45" *ngFor="let _ of [1,2,3,4,5,6,7,8]">
                        <span class="placeholder col-12"></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column bd-highlight sticky-footer-container">
            <div class="mb-2">
                <div class="share-button" (click)="openCanvas(uploadImg)"
                    [ngStyle]="{'background-color': data.colors.secondary_color}">
                    <i class="bi bi-camera" [ngStyle]="{'color': data.colors.text_color}"></i>
                </div>
            </div>
            <div class="mb-2" id="back-to-top" (click)="functionService.scrollToTop('.preview-main-wrapper')">
                <div class="share-button" [ngStyle]="{'background-color': data.colors.secondary_color}"
                    data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="left" title="Back to top">
                    <i class="bi bi-chevron-up" [ngStyle]="{'color': data.colors.text_color}"></i>
                </div>
            </div>
            <div class="mb-2" *ngIf="data.show_qr_code">
                <div class="share-button" data-bs-custom-class="qr-preview-tooltip"
                    [ngStyle]="{'background-color': data.colors.secondary_color}" data-bs-toggle="tooltip"
                    data-bs-trigger="hover focus" data-bs-placement="left" data-bs-html="true"
                    title="<img src='{{qr_url}}' class='rounded' height='170' width='170'>">
                    <i class="bi bi-qr-code-scan" [ngStyle]="{'color': data.colors.text_color}"></i>
                </div>
            </div>
            <div class="mb-2" *ngIf="data.share_on">
                <div class="share-button" [ngStyle]="{'background-color': data.colors.secondary_color}">
                    <app-share-to-social [data]="social_data" [size]="32"
                        [text_color]="data.colors.text_color"></app-share-to-social>
                </div>
            </div>
        </div>
    </div>

    <!-- UPLOAD PICTURE MODAL -->
    <div class="offcanvas offcanvas-end" data-bs-backdrop="false" [formGroup]="uploader" tabindex="-1" [id]="uploadImg">
        <div class="offcanvas-header" [ngStyle]="{'background-color': data.colors.primary_color}">
            <h5 [ngStyle]="{'color': data.colors.text_color}">Upload Memories to {{data.headings.main}}</h5>
            <button type="button" (click)="showGalleryItems()" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">

            <div class="mb-4">
                <label class="form-label">Caption<i class="bi bi-info-circle mouse-pointer ms-1"
                        data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top"
                        title="Captions are essential for providing context."></i></label>
                <input type="text" class="form-control" maxlength="60"
                    [class.is-invalid]="uploader.get('description').hasError('required') && uploader.get('description').touched"
                    formControlName="description" placeholder="Example: Through Jane's lens (Optional)">
                <p class="input-error"
                    *ngIf="uploader.get('description').hasError('required') && uploader.get('description').touched">
                    Caption
                    is required!</p>
            </div>

            <p>Upload or drag and drop images to submit your memories.</p>
            <div class="uploader">
                <input id="upload-images" #myFileInput multiple="multiple" (change)="fileChangeEvent($event);"
                    type="file" name="fileUpload" accept="image/*, video/*">
                <label for="upload-images" (mouseenter)="changeBorderColor($event.target, data.colors.primary_color)"
                    (mouseleave)="changeBorderColor($event.target, '#E9E9E9')" appDragndrop
                    (onFileDropped)="fileChangeEvent($event)" id="file-drag">
                    <div class="py-3">
                        <img loading="lazy" src="assets/picture.png">
                    </div>
                    <p>Drag and drop images here</p>
                    <app-loading *ngIf="uploading_images; else notUploading" processing="uploading" type="percentage"
                        [color]="data.colors.primary_color"
                        [percentage_obs]="percentage_obs.asObservable()"></app-loading>
                    <ng-template #notUploading>
                        <span id="file-upload-btn"
                            [ngStyle]="{'background-color': data.colors.primary_color, 'border-color': data.colors.primary_color}"
                            class="btn btn-secondary">
                            Select a file
                        </span>
                    </ng-template>
                </label>
            </div>

            <div class="file-main-wrapper my-4" formGroupName="assets">
                <div class="img-file-wrapper" *ngFor="let image of uploader.controls.assets.controls; let i = index"
                    [formGroupName]="i">
                    <div class="file-body">
                        <div class="file-icon p-2 me-1">
                            <app-inline-loader type="square" *ngIf="!image.controls.url.value; else uploadCompleted"
                                [square_color]="data.colors.primary_color"></app-inline-loader>
                            <ng-template #uploadCompleted>
                                <img loading="lazy" [src]="image.controls.url.value"
                                    *ngIf="!isVideoFile(image.controls.url.value); else isVideo" height="70">
                                <ng-template #isVideo>
                                    <video height="70" controls>
                                        <source [src]="image.controls.url.value" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </ng-template>
                            </ng-template>
                        </div>
                        <div class="file-name">
                            <b class="mb-n2">{{image.controls.name.value}}</b>
                            <small *ngIf="image.controls.size?.value">{{image.controls.size.value}}</small>
                        </div>
                    </div>
                    <div class="file-close">
                        <i *ngIf="image.controls.url.value" [ngStyle]="{color: data.colors.primary_color}"
                            class="bi bi-check2-all"></i>
                        <!-- <i (click)="removeImages(i)" *ngIf="image.controls.url.value" class="bi bi-x mouse-pointer"></i> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

    <!-- Background of PhotoSwipe.
         It's a separate element, as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

        <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
        <!-- don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

            <div class="pswp__top-bar">

                <!--  Controls are self-explanatory. Order can be changed. -->

                <div class="pswp__counter"></div>

                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                <button class="pswp__button pswp__button--share" title="Share"></button>

                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                <!-- element will get class pswp__preloader--active when preloader is running -->
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>

            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>

            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>

            <div class="pswp__caption">
                <div class="pswp__caption__center text-center"></div>
            </div>

        </div>

    </div>

</div>